const FoundersAboutSection = () => {
  return (
    <section id="about" className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="fade-in-left">
            <h2 className="heading-text mb-8 text-foreground">
              About Me
            </h2>
            <div className="space-y-6 text-muted-foreground leading-relaxed">
              <p className="text-lg">
                With over a decade of experience in visual storytelling, I've had the privilege
                of working with brands, artists, and filmmakers who dare to push creative boundaries.
                My journey began in the underground music scene, where raw emotion and authentic
                storytelling shaped my artistic vision.
              </p>

              <p>
                From intimate documentaries to large-scale commercial productions, I bring a
                cinematic approach that captures not just what you see, but what you feel.
                My work has been featured in international film festivals and has helped launch
                careers and brands across the globe.
              </p>

              <p>
                I believe that every project is an opportunity to create something extraordinary.
                Whether it's a 30-second commercial or a feature-length narrative, I approach
                each frame with the same dedication to excellence and artistic integrity.
              </p>

              <div className="grid grid-cols-2 gap-6 pt-6">
                <div>
                  <h4 className="font-semibold text-foreground mb-2">Experience</h4>
                  <p className="text-sm">10+ Years</p>
                </div>
                <div>
                  <h4 className="font-semibold text-foreground mb-2">Projects</h4>
                  <p className="text-sm">200+ Completed</p>
                </div>
                <div>
                  <h4 className="font-semibold text-foreground mb-2">Awards</h4>
                  <p className="text-sm">15+ International</p>
                </div>
                <div>
                  <h4 className="font-semibold text-foreground mb-2">Clients</h4>
                  <p className="text-sm">50+ Satisfied</p>
                </div>
              </div>
            </div>
          </div>

          {/* Photo */}
          <div className="fade-in-right">
            <div className="relative">
              <div className="shadow-dramatic rounded-lg overflow-hidden">
                <img
                  src="/founder1.jpg"
                  alt="Founder"
                  className="relative rounded-2xl w-full h-auto shadow-2xl"
                />
              </div>
              {/* Decorative accent */}
              <div className="absolute -bottom-6 -right-2 w-24 h-24 accent-gradient rounded-lg -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersAboutSection;